import React from 'react';
import { ReactLenis } from '@studio-freight/react-lenis';

export default function SmoothScroll({ children }) {
  return (
    <ReactLenis root options={{
      lerp: 0.05, // Lower is smoother/slower
      duration: 1.5,
      smoothTouch: false, // Keep native touch scrolling for better mobile UX usually
    }}>
      {children}
    </ReactLenis>
  );
}